import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import cn from "classnames";
import { Skeleton } from "@material-ui/lab";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    rootVertical: {
      flexDirection: "column",
      gap: theme.spacing(2),
      "& >*": {
        marginLeft: "0 !important",
      },
      "& .MuiTextField-root": {
        marginLeft: "0 !important",
      },
    },
  });

export type ReportToolbarProps = {
  className?: string;
  style?: React.CSSProperties;
  vertical?: boolean;
  isLoading?: boolean;
};

type Props = ReportToolbarProps & WithStyles<typeof styles>;
const CHILD_HEIGHT = 51;
const CHILD_WIDTH = 160;
const HORIZONTAL_GAP = 8;
const VERTICAL_GAP = 16;
class ReportToolbarGroup extends React.Component<Props> {
  render() {
    const { classes, className, children, vertical, isLoading, style } = this.props;

    if (isLoading) {
      const childrenCount = React.Children.count(children);
      const height = vertical ? childrenCount * (CHILD_HEIGHT + VERTICAL_GAP) - VERTICAL_GAP : CHILD_HEIGHT;
      const width = vertical ? CHILD_WIDTH : childrenCount * (CHILD_WIDTH + HORIZONTAL_GAP) - HORIZONTAL_GAP;
      return <Skeleton variant="rect" width={width} height={height} />;
    }
    return (
      <div style={style} className={cn("ReportToolbarGroup", classes.root, { [classes.rootVertical]: vertical }, className)}>
        {children}
      </div>
    );
  }
}

export default withStyles(styles)(ReportToolbarGroup);
